module.exports = __webpack_public_path__ + "static/media/cross.db254de4.svg";